module.exports = __webpack_public_path__ + "static/media/contratosuministro.176b34d0.svg";